module.exports = __webpack_public_path__ + "img/hr-green-croton-07.ac3ba3b9.png";